import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const contactPathMap = localizePathMap({
	[Locale.cs]: "kontakt",
	[Locale.en]: "contact",
});
